import { ArrowRight, Megaphone } from "@phosphor-icons/react"
import { ErrorBoundary } from "@sentry/nextjs"
import { Divider } from "@tokenterminal/core/ui/layout/divider/Divider"
import { Badge } from "@tokenterminal/core/ui/messaging/badge/Badge"
import Container from "../common/Container"
import Layout from "../common/Layout"
import ContactUs from "./ContactUs"
import CustomerGrid from "./CustomerGrid"
import FullStackDataPlatform from "./FullStackDataPlatform"
import Hero from "./hero/Hero"
import ProductShowcaseMasonry from "./ProductShowcaseMasonry"
import SolutionsForEveryScale from "./SolutionsForEveryScale"
import Testimonials from "./Testimonials"

const HomePage = () => {
  return (
    <Layout>
      <Container>
        <div className="flex justify-center items-start gap-2 pt-4 md:pt-8 pb-10 md:pb-20 w-full">
          <a
            href="https://tokenterminal.com/resources/newsletter/token-terminal-mcp-is-here"
            target="_blank"
            rel="noreferrer noopener"
            className="w-full md:w-auto animate-fade-in outline-hidden rounded-2xl focus-visible:outline-solid focus-visible:outline-sky-500 focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            {/* Mobile */}
            <Badge
              size="large"
              variant="muted"
              className="flex md:hidden rounded-3xl justify-center"
            >
              <div className="flex flex-col gap-1.5 p-1 w-full">
                <div className="flex items-center justify-between w-full">
                  <div className="flex flex-col">
                    <div className="flex items-center gap-1.5">
                      <Megaphone size={12} className="shrink-0" />
                      <span className="text-xs">Announcement</span>
                    </div>
                  </div>
                  <ArrowRight size={12} className="shrink-0" />
                </div>
                <span className="text-sm font-normal text-pretty">
                  Token Terminal MCP is here
                </span>
              </div>
            </Badge>
            {/* Desktop */}
            <Badge
              size="large"
              variant="muted"
              className="hidden md:flex rounded-3xl justify-center group"
            >
              <div className="flex justify-between gap-2 items-center p-1">
                <div className="flex items-center gap-2">
                  <Megaphone size={14} className="shrink-0" />
                  <span className="text-sm">Announcement</span>
                </div>
                <Divider orientation="vertical" />
                <span className="text-sm font-normal">
                  Token Terminal MCP is here
                </span>
                <ArrowRight
                  size={14}
                  className="shrink-0 -translate-x-px group-hover:translate-x-px transition-transform duration-300"
                />
              </div>
            </Badge>
          </a>
        </div>
      </Container>
      <Hero />
      <Container>
        <CustomerGrid />
      </Container>
      <FullStackDataPlatform />
      <ErrorBoundary>
        <Container>
          <ProductShowcaseMasonry />
        </Container>
      </ErrorBoundary>
      {/* <div>
        <Container>
          <FeatureCallouts features={featureCallouts} />
        </Container>
      </div> */}
      <Testimonials />
      <div className="text-[50px] md:pt-[120px] md:pb-[50px] lg:pt-[250px] lg:pb-[150px]">
        <Container>
          <SolutionsForEveryScale />
        </Container>
      </div>
      {/* This was the old anchor link id for the contact section. Changed it to the more generic "contact" but kept this here for "backwards compatibility" of old links. */}
      <div id="landing-sales-form" />
      <div
        id="contact"
        className="bg-linear-to-b from-bg-default to-bg-surface"
      >
        <ContactUs />
      </div>
    </Layout>
  )
}

export default HomePage
